export default {"src":"/_next/static/media/education-cap.93bb09f8.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};